import axios from "axios";
import AA_GLOBAL from "./globals/globals";
import store from "./store";
import ACTIONS from "./actions/types";
import { forgetSession } from "./functions/authSession";

export let axiosWithAuth = axios.create({
  baseURL: AA_GLOBAL.baseURL,
  // the auth_token cookie authenticates; a REACT_APP_BASE_URL on another origin needs it sent
  withCredentials: true,
  headers: {
    gcommit: process.env.REACT_APP_GIT_COMMIT || "",
    "accept-language": AA_GLOBAL.cookies.get("lang") || "*",
  },
});

axiosWithAuth.CancelToken = axios.CancelToken;

axiosWithAuth.isCancel = axios.isCancel;

axiosWithAuth.interceptors.response.use(
  res => res,
  error => {
    switch (error.response && error.response.status) {
      case 401:
        // Unauthorized
        forgetSession();
        window.location.pathname = "/ui/auth";
        break;
      case 403:
        // Forbidden
        // FIXME: shouldn't necessarily mean that the user did something unauthorized
        forgetSession();
        window.location.pathname = "/ui/403";
        break;
      case 500:
        store.dispatch({ type: ACTIONS.ERROR_POPUP });
        break;
      default:
    }
    return Promise.reject(error);
  }
);

export const methodOverrideInterceptor = config => {
  const httpMethod = config.method;
  if (httpMethod?.toLowerCase() === "patch") {
    if (!config.data) {
      config.data = {};
    }
    config.data._method = httpMethod;
    config.method = "post";
  }

  return config;
};

axiosWithAuth.interceptors.request.use(methodOverrideInterceptor);
